import React from 'react'

import { HStack, Image } from '@chakra-ui/react'

import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import { nationalityOptions } from '@core/components/ApplyDialogV2/ApplyV2ProfileStep/helpers/nationalityOptions'
import type { FlagOption } from '@core/components/FlagSelect/FlagSelect'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import formatPhoneNumber from '@core/utils/helpers/formatPhoneNumber'
import getAddressStringFromObject from '@core/utils/helpers/getAddressStringFromObject'
import { prefixes } from '@core/utils/helpers/prefixes'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
import useFormattedDatesPeriod from '@core/utils/hooks/useFormattedDatesPeriod'
import useGetGenderString from '@core/utils/hooks/useGetGenderString'
import './ApplyV2ReviewApplyProfile.scss'

interface ApplyV2ReviewApplyProfileProps {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyProfile'

function ApplyV2ReviewApplyProfile({ className = '' }: ApplyV2ReviewApplyProfileProps) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        settingsData,
    } = useApplyV2Context()
    const { getTitle } = useApplyV2NavTranslations()
    const { formatDateRange, formatDuration } = useFormattedDatesPeriod()

    const profileData = postProfileData?.data?.profile
    const profileFields = settingsData?.steps?.profile?.fields

    const getFlagPath = (prefixes: FlagOption[]) => {
        return prefixes.find(
            (obj) =>
                obj.prefix === profileData?.mobilePhone?.prefix || obj.prefix === `+${profileData?.mobilePhone?.prefix}`
        )?.code
    }

    const flagPath = getFlagPath(prefixes)

    const orderedList = Object.values(profileFields ?? {})
        .sort((a, b) => a.order - b.order)
        .filter((it) => it.visible && profileData?.[it.name])
    // .map((it) => {
    //     return { name: it.name, data: profileData?.[it.name] }
    // })

    return (
        <div className={`${baseClass} ${className}`}>
            {orderedList?.map((item) => {
                switch (item.name) {
                    // case 'firstName':
                    //     return (
                    //         <ApplyV2DataRow key={item.name} title={getTitle('169', 'First name')}>
                    //             {decodeHtmlEntitiesRecursive(profileData?.firstName)}
                    //         </ApplyV2DataRow>
                    //     )
                    // case 'lastName':
                    //     return (
                    //         <ApplyV2DataRow key={item.name} title={getTitle('170', 'Last name')}>
                    //             {decodeHtmlEntitiesRecursive(profileData?.lastName)}
                    //         </ApplyV2DataRow>
                    //     )
                    case 'firstName':
                        return (
                            <ApplyV2DataRow key={item.name} title={getTitle('63', 'Name')}>
                                {decodeHtmlEntitiesRecursive(profileData?.firstName)}{' '}
                                {decodeHtmlEntitiesRecursive(profileData?.lastName)}
                            </ApplyV2DataRow>
                        )
                    case 'email':
                        return (
                            <ApplyV2DataRow key={item.name} title={getTitle('92', 'Email')} fieldType={'email'}>
                                {decodeHtmlEntitiesRecursive(profileData?.email)}
                            </ApplyV2DataRow>
                        )
                    case 'linkedin':
                        return (
                            <ApplyV2DataRow
                                key={item.name}
                                title={getTitle('9691', 'LinkedIn profile link')}
                                fieldType={'link'}
                            >
                                {decodeHtmlEntitiesRecursive(profileData?.linkedin)}
                            </ApplyV2DataRow>
                        )
                    case 'mobilePhone':
                        return (
                            <ApplyV2DataRow
                                key={item.name}
                                title={getTitle('137', 'Mobile phone')}
                                fieldType={'mobilePhone'}
                            >
                                <HStack>
                                    {prefixes && profileData?.mobilePhone?.prefix && flagPath && (
                                        <Image
                                            maxW={4}
                                            src={`${
                                                process.env.ENV === 'local'
                                                    ? process.env.API_URL
                                                    : window.location.origin
                                            }/${flagPath}`}
                                            alt={profileData?.mobilePhone?.prefix}
                                        />
                                    )}
                                    <span>{formatPhoneNumber(profileData?.mobilePhone)}</span>
                                </HStack>
                            </ApplyV2DataRow>
                        )
                    case 'gender':
                        return (
                            <ApplyV2DataRow key={item.name} title={getTitle('66', 'Gender')} fieldType={'gender'}>
                                {useGetGenderString(profileData?.gender)}
                            </ApplyV2DataRow>
                        )
                    case 'dateOfBirth':
                        return (
                            <ApplyV2DataRow
                                key={item.name}
                                title={getTitle('131', 'Date of birth')}
                                fieldType={'birthdate'}
                            >
                                {/*{profileData?.dateOfBirth}*/}
                                {formatDateRange(profileData?.dateOfBirth, null, {
                                    isShowPresent: false,
                                    dateFormat: 'D MMMM YYYY',
                                })}
                            </ApplyV2DataRow>
                        )
                    case 'address':
                        return (
                            <ApplyV2DataRow key={item.name} title={getTitle('1249', 'Location')} fieldType={'location'}>
                                {getAddressStringFromObject(profileData?.address)}
                            </ApplyV2DataRow>
                        )
                    case 'nationality':
                        return (
                            <ApplyV2DataRow key={item.name} title={getTitle('132', 'Nationality')}>
                                {nationalityOptions.find((n) => n.id === profileData?.nationality)?.name}
                            </ApplyV2DataRow>
                        )
                    default:
                        return null
                }
            })}
            {/*{!!profileData?.firstName && <ApplyV2DataRow title={'First name'}>{profileData?.firstName}</ApplyV2DataRow>}*/}
            {/*{!!profileData?.lastName && <ApplyV2DataRow title={'Last name'}>{profileData?.lastName}</ApplyV2DataRow>}*/}
            {/*{!!profileData?.email && (*/}
            {/*    <ApplyV2DataRow title={'Email'} fieldType={'email'}>*/}
            {/*        {profileData?.email}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {/*{!!profileData?.linkedin && (*/}
            {/*    <ApplyV2DataRow title={'LinkedIn profile link'} fieldType={'link'}>*/}
            {/*        {profileData?.linkedin}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {/*{!!profileData?.mobilePhone && (*/}
            {/*    <ApplyV2DataRow title={'Mobile phone'} fieldType={'mobilePhone'}>*/}
            {/*        <HStack>*/}
            {/*            {prefixes && profileData?.mobilePhone?.prefix && flagPath && (*/}
            {/*                <Image*/}
            {/*                    maxW={4}*/}
            {/*                    src={`${*/}
            {/*                        process.env.ENV === 'local' ? process.env.API_URL : window.location.origin*/}
            {/*                    }/${flagPath}`}*/}
            {/*                    alt={profileData?.mobilePhone?.prefix}*/}
            {/*                />*/}
            {/*            )}*/}
            {/*            <span>{formatPhoneNumber(profileData?.mobilePhone)}</span>*/}
            {/*        </HStack>*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {/*{!!profileData?.gender && profileData?.gender > 0 && (*/}
            {/*    <ApplyV2DataRow title={'Gender'} fieldType={'gender'}>*/}
            {/*        {useGetGenderString(profileData?.gender)}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {/*{!!profileData?.dateOfBirth && (*/}
            {/*    <ApplyV2DataRow title={'Date of birth'} fieldType={'birthdate'}>*/}
            {/*        /!*{profileData?.dateOfBirth}*!/*/}
            {/*        {formatDateRange(profileData?.dateOfBirth, null, {*/}
            {/*            isShowPresent: false,*/}
            {/*            dateFormat: 'D MMMM YYYY',*/}
            {/*        })}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
            {/*{getAddressStringFromObject(profileData?.address) && (*/}
            {/*    <ApplyV2DataRow title={'Location'} fieldType={'location'}>*/}
            {/*        {getAddressStringFromObject(profileData?.address)}*/}
            {/*    </ApplyV2DataRow>*/}
            {/*)}*/}
        </div>
    )
}

export default ApplyV2ReviewApplyProfile
